export const LOGIN = '/login';
export const ERROR = '/error';
export const VERSION = '/version';
export const CUSTOMER_DETAIL = '/customer-detail';
export const SAP_IFRAME = '/sap-iframe';
export const COMPANY_INFO = '/impressum';
export const CONFIDENTIALITY = '/datenschutzerklaerung';
export const MESSAGE_TO_CLIENT = '/message_to_client';
export const MESSAGE_TO_AGENCY = '/message_to_agency';
export const THANKS = '/thanks';
export const FEEDBACK = '/feedback';
export const QUALTRICS_FEEDBACK = '/qualtrics-feedback';

export const POST_BOX = '/post-box';
export const STATUS = '/status';
export const RECOMMEND_HELP = '/recommend-help';
export const PROFILE = '/profile';

export const HOME = '/';
export const PAYMENTS = '/payments';
export const PAYMENT_REDIRECT = '/payment-redirect';
export const PAYMENT_SUCCESS = '/payment_success';
export const CALCULATOR_AWAIT = '/calculator-await';

export const ZIP_CODE_VALIDATION = '/zip-code';
